module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isLoading) ? _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "boldTitle largeTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.isHcpUser || !_vm.isHcpView) ? _c('reset-account') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('avatar-uploader') : _vm._e(), _vm._v(" "), _c('update-height'), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(!_vm.hideNameInputs) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "data-vv-name": "firstname",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesFirstName'),
      "errorText": _vm.errors.first('firstname'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesFirstName')
    },
    model: {
      value: (_vm.model.firstname),
      callback: function($$v) {
        _vm.$set(_vm.model, "firstname", $$v)
      },
      expression: "model.firstname"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(!_vm.hideNameInputs) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 40,
        regex: /^[a-zA-Z ]*$/
      }),
      expression: "{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
    }],
    attrs: {
      "data-vv-name": "surname",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesSurname'),
      "errorText": _vm.errors.first('surname'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesSurname')
    },
    model: {
      value: (_vm.model.surname),
      callback: function($$v) {
        _vm.$set(_vm.model, "surname", $$v)
      },
      expression: "model.surname"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [(_vm.hideNameInputs) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required|display_name_regex|min:2|max:30',
      "data-vv-name": "display_name",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDisplayName'),
      "errorText": _vm.errors.first('display_name'),
      "fullWidth": true,
      "label": _vm.$t('message.accountPreferencesDisplayName')
    },
    model: {
      value: (_vm.model.display_name),
      callback: function($$v) {
        _vm.$set(_vm.model, "display_name", $$v)
      },
      expression: "model.display_name"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-row', [_c('p', [_vm._v(_vm._s(_vm.$t('Show username instead of first and last name')))]), _vm._v(" "), _c('mu-switch', {
    on: {
      "change": _vm.switchInputs
    },
    model: {
      value: (_vm.model.use_display_name),
      callback: function($$v) {
        _vm.$set(_vm.model, "use_display_name", $$v)
      },
      expression: "model.use_display_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-card-text'), _vm._v(" "), _c('mu-divider')], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "birth_day",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelDay'),
      "errorText": _vm.errors.first('birth_day'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesBirthday')
    },
    model: {
      value: (_vm.dob.day),
      callback: function($$v) {
        _vm.$set(_vm.dob, "day", $$v)
      },
      expression: "dob.day"
    }
  }, _vm._l((_vm.dobItems.days), function(item, index) {
    return _c('mu-menu-item', {
      key: 'dob-day-' + index,
      attrs: {
        "value": item,
        "title": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "birth_month",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelMonth'),
      "errorText": _vm.errors.first('birth_month'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "autoWidth": "",
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": " "
    },
    model: {
      value: (_vm.dob.month),
      callback: function($$v) {
        _vm.$set(_vm.dob, "month", $$v)
      },
      expression: "dob.month"
    }
  }, _vm._l((_vm.dobItems.months), function(month, index) {
    return _c('mu-menu-item', {
      key: 'month-' + index,
      attrs: {
        "value": month,
        "title": _vm.localizeMonth(month.name)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": true,
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "birth_year",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.labelYear'),
      "errorText": _vm.errors.first('birth_year'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": " "
    },
    model: {
      value: (_vm.dob.year),
      callback: function($$v) {
        _vm.$set(_vm.dob, "year", $$v)
      },
      expression: "dob.year"
    }
  }, _vm._l((_vm.dobItems.years), function(year, index) {
    return _c('mu-menu-item', {
      key: 'year-' + index,
      attrs: {
        "value": year,
        "title": '' + year.value + ''
      }
    })
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col')], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "diabetes_type",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesWhatBringsYouHere'),
      "errorText": _vm.errors.first('diabetes_type'),
      "maxHeight": 216,
      "label": _vm.$t('message.accountPreferencesWhatBringsYouHere'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.model.diabetes_type_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "diabetes_type_id", $$v)
      },
      expression: "model.diabetes_type_id"
    }
  }, _vm._l((_vm.lists.diabetes_types), function(item, index) {
    return (item.hide === 0) ? _c('mu-menu-item', {
      key: 'diabetes-type-' + index,
      attrs: {
        "title": _vm.localizeRegistrationReason(item.diabetes_type),
        "value": item.diabetes_type_id
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "diagnosis_year",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDiagnosisYear'),
      "errorText": _vm.errors.first('diagnosis_year'),
      "maxHeight": 216,
      "label": _vm.$t('message.accountPreferencesDiagnosisYear'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.model.diagnosis_year),
      callback: function($$v) {
        _vm.$set(_vm.model, "diagnosis_year", _vm._n($$v))
      },
      expression: "model.diagnosis_year"
    }
  }, _vm._l((_vm.yearList()), function(item, index) {
    return _c('mu-menu-item', {
      key: 'diagnosis-year+' + index,
      attrs: {
        "title": '' + item + '',
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "gender",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesSex'),
      "errorText": _vm.errors.first('gender'),
      "maxHeight": 216,
      "label": _vm.$t('message.accountPreferencesSex'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.model.gender_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "gender_id", $$v)
      },
      expression: "model.gender_id"
    }
  }, _vm._l((_vm.lists.genders), function(item, index) {
    return _c('mu-menu-item', {
      key: 'gender-' + index,
      attrs: {
        "title": _vm.localizeSex(item.gender),
        "value": item.gender_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.accountPreferencesTestBlood')
    },
    model: {
      value: (_vm.model.tests_blood),
      callback: function($$v) {
        _vm.$set(_vm.model, "tests_blood", $$v)
      },
      expression: "model.tests_blood"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.accountPreferencesTakeMedication')
    },
    model: {
      value: (_vm.model.takes_medication),
      callback: function($$v) {
        _vm.$set(_vm.model, "takes_medication", $$v)
      },
      expression: "model.takes_medication"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "ethnicity",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "day",
      "errorText": _vm.errors.first('ethnicity'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesEthnicity')
    },
    model: {
      value: (_vm.personalizationModel.ethnicity_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "ethnicity_id", $$v)
      },
      expression: "personalizationModel.ethnicity_id"
    }
  }, _vm._l((_vm.lists.ethnicities), function(item, index) {
    return _c('mu-menu-item', {
      key: 'ethnicity-' + index,
      attrs: {
        "value": item.ethnicity_id,
        "title": _vm.$t(_vm.localizeEthnicity(item.ethnicity_id))
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "language",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesLanguage'),
      "errorText": _vm.errors.first('language'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": "Select",
      "label": _vm.$t('message.accountPreferencesLanguage')
    },
    model: {
      value: (_vm.personalizationModel.language_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "language_id", $$v)
      },
      expression: "personalizationModel.language_id"
    }
  }, _vm._l((_vm.lists.languages), function(item, index) {
    return _c('mu-menu-item', {
      key: 'language-' + index,
      attrs: {
        "value": item.id,
        "title": _vm.getNativeName(item.iso)
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "occupation",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesOccupation'),
      "errorText": _vm.errors.first('occupation'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesOccupation')
    },
    model: {
      value: (_vm.personalizationModel.occupation_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "occupation_id", $$v)
      },
      expression: "personalizationModel.occupation_id"
    }
  }, _vm._l((_vm.lists.occupations), function(item, index) {
    return _c('mu-menu-item', {
      key: 'occupation-' + index,
      attrs: {
        "value": item.occupation_id,
        "title": _vm.localizeOccupation(item.occupation_name)
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "dietary_preference",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDietaryPreference'),
      "errorText": _vm.errors.first('dietary_preference'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 200,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesDietaryPreference')
    },
    model: {
      value: (_vm.personalizationModel.dietry_preference_id),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "dietry_preference_id", $$v)
      },
      expression: "personalizationModel.dietry_preference_id"
    }
  }, _vm._l((_vm.lists.dietry_preferences), function(item, index) {
    return _c('mu-menu-item', {
      key: 'diet-pref-' + index,
      attrs: {
        "value": item.dietry_preference_id,
        "title": _vm.localizeDietPreference(item.name)
      }
    })
  }), 1), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "multiple": "",
      "separator": ", ",
      "autoWidth": "",
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesAllergies')
    },
    model: {
      value: (_vm.personalizationModel.allergies),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "allergies", $$v)
      },
      expression: "personalizationModel.allergies"
    }
  }, _vm._l((_vm.lists.allergies), function(item, index) {
    return _c('mu-menu-item', {
      key: 'allergy-' + index,
      attrs: {
        "value": item.allergy_id,
        "title": _vm.localizeAllergy(item.name)
      }
    })
  }), 1), _vm._v(" "), (_vm.personalizationModel.currency_code) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.personalizationModel.currency_code),
      expression: "personalizationModel.currency_code"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.personalizationModel.currency_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.personalizationModel, "currency_code", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('currency-input', {
    attrs: {
      "currency": _vm.currencyCode,
      "label": _vm.$t('message.accountPreferencesShopCost')
    },
    model: {
      value: (_vm.personalizationModel.weekly_shop_cost),
      callback: function($$v) {
        _vm.$set(_vm.personalizationModel, "weekly_shop_cost", _vm._n($$v))
      },
      expression: "personalizationModel.weekly_shop_cost"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "secondary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "fullWidth": ""
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "316px"
    },
    attrs: {
      "justify": "center center",
      "align": "center center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 46
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc673878","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/General.vue
// module id = 3851
// module chunks = 1